import {useEffect, useState} from 'react';
import {postAuthEmailGuardAlternateSend} from 'api/auth';
import {alertByError} from 'utils/alerts';

function useSendEmailGuard(session) {
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);

  useEffect(() => {
    return () => {
      setIsSending(false);
      setIsSent(false);
    };
  }, []);

  const {two_factor_session_id} = session || {};

  useEffect(() => {
    sendEmailGuard();
  }, []);

  async function sendEmailGuard() {
    setIsSending(true);
    try {
      await postAuthEmailGuardAlternateSend({two_factor_session_id});

      setIsSending(false);
    } catch (e) {
      await alertByError(e);
      setIsSending(false);
    }
  }

  async function resendEmailGuard() {
    await sendEmailGuard();
    setIsSent(true);
  }

  return {
    isSent,
    isSending,
    onSendEmailGuard: sendEmailGuard,
    onResendEmailGuard: resendEmailGuard,
  };
}

export default useSendEmailGuard;
